var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankNote0332(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECE9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 14.0007H15.6667C15.1144 14.0007 14.6667 14.4484 14.6667 15.0007C14.6667 15.5529 15.1144 16.0007 15.6667 16.0007H16.3334C16.8857 16.0007 17.3334 16.4484 17.3334 17.0007C17.3334 17.5529 16.8857 18.0007 16.3334 18.0007H14.6667M16 13.334V14.0007M16 18.0007V18.6673M20 16.0007H20.0067M12 16.0007H12.0067M9.33337 13.4673L9.33337 18.534C9.33337 19.2807 9.33337 19.6541 9.4787 19.9393C9.60653 20.1902 9.8105 20.3942 10.0614 20.522C10.3466 20.6673 10.72 20.6673 11.4667 20.6673L20.5334 20.6673C21.2801 20.6673 21.6535 20.6673 21.9387 20.522C22.1896 20.3942 22.3936 20.1902 22.5214 19.9393C22.6667 19.6541 22.6667 19.2807 22.6667 18.534V13.4673C22.6667 12.7206 22.6667 12.3472 22.5214 12.062C22.3936 11.8111 22.1896 11.6071 21.9387 11.4793C21.6535 11.334 21.2801 11.334 20.5334 11.334L11.4667 11.334C10.72 11.334 10.3466 11.334 10.0614 11.4793C9.8105 11.6071 9.60653 11.8111 9.4787 12.062C9.33337 12.3472 9.33337 12.7206 9.33337 13.4673ZM20.3334 16.0007C20.3334 16.1847 20.1841 16.334 20 16.334C19.8159 16.334 19.6667 16.1847 19.6667 16.0007C19.6667 15.8166 19.8159 15.6673 20 15.6673C20.1841 15.6673 20.3334 15.8166 20.3334 16.0007ZM12.3334 16.0007C12.3334 16.1847 12.1841 16.334 12 16.334C11.8159 16.334 11.6667 16.1847 11.6667 16.0007C11.6667 15.8166 11.8159 15.6673 12 15.6673C12.1841 15.6673 12.3334 15.8166 12.3334 16.0007Z",
    stroke: "#624CE0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNote0332);
export default __webpack_public_path__ + "static/media/bank-note-03-32.3230f8c7fb36ec8a5f08e6c5a42f61b6.svg";
export { ForwardRef as ReactComponent };